// Declare commonlyb used elements as constants
const MOBILEMENU = document.getElementById("menu-mobile") as HTMLElement | null;
const LOGINMENU = document.getElementById("menu-login") as HTMLElement | null;
const SEARCHMENU = document.getElementById("menu-search") as HTMLElement | null;
const APPMODAL = document.getElementById("menu-app") as HTMLElement | null;
const MENUSHROUD = document.getElementById("menu-shroud") as HTMLElement | null;
const DROPDOWNSHROUD = document.getElementById("dropdown-shroud") as HTMLElement | null;
const POPUPALERT = document.getElementById("popup-alert") as HTMLElement | null
const BODY = document.querySelector("body") as HTMLElement;


function toggleMobileMenu(isOpen?: boolean): void {
	if (MOBILEMENU && MENUSHROUD && BODY) {
		MOBILEMENU.classList.toggle("open");
		if(MOBILEMENU.classList.contains("open")) {
			focusFirst(MOBILEMENU);
		}
		MENUSHROUD.classList.toggle("active");
		BODY.classList.toggle("menu-open");
		document.querySelectorAll(".js-mobile-menu").forEach(x => (x as HTMLElement).classList.toggle("open"));
	}
}
function openMobileMenu() {
	if(MOBILEMENU) {
		MOBILEMENU.classList.add("open");
		focusFirst(MOBILEMENU);
		MENUSHROUD.classList.toggle("active");
		BODY.classList.toggle("menu-open");
		let mobileMenuButtons = document.querySelectorAll(".js-mobile-menu");
		Array.from(mobileMenuButtons).map((x) => x.classList.add("open"));
	}
}
function closeMobileMenu() {
	if(MOBILEMENU) {
		MOBILEMENU.classList.remove("open");
		MENUSHROUD.classList.toggle("active");
		BODY.classList.toggle("menu-open");
		let mobileMenuButtons = document.querySelectorAll(".js-mobile-menu");
		Array.from(mobileMenuButtons).map((x) => x.classList.remove("open"));
	}
}
// Mobile Menu ESC close
if(MOBILEMENU && !MOBILEMENU.classList.contains("esc-bound")) {
    MOBILEMENU.addEventListener("keyup", function(event) {
        if(event.keyCode === 27) {
        	let activeSubmenu = MOBILEMENU.querySelector(".js-slide-menu.active");
        	if(activeSubmenu) {
        		//closeMobileSubnav(activeSubmenu.querySelector(".js-slide-menu-close"));
        	} else {
	            closeMobileMenu();
        	}
        }
    });
    MOBILEMENU.classList.add("esc-bound");
}






// Login Menu
function toggleLoginMenu() {
	if(LOGINMENU) {
		LOGINMENU.classList.toggle("open");
		if(LOGINMENU.classList.contains("open")) {
			focusFirst(LOGINMENU);
		}
		MENUSHROUD.classList.toggle("active");
		BODY.classList.toggle("menu-open");
		let loginButtons = document.querySelectorAll(".js-login-menu");
		Array.from(loginButtons).map((x) => x.classList.toggle("open"));
	}
}
function openLoginMenu() {
	if(LOGINMENU) {
		MENUSHROUD.classList.toggle("active");
		BODY.classList.toggle("menu-open");
		LOGINMENU.classList.add("open");
		focusFirst(LOGINMENU);
		let loginButtons = document.querySelectorAll(".js-login-menu");
		Array.from(loginButtons).map((x) => x.classList.add("open"));
	}
}
function closeLoginMenu() {
	if(LOGINMENU) {
		MENUSHROUD.classList.toggle("active");
		BODY.classList.toggle("menu-open");
		LOGINMENU.classList.remove("open");
		let loginButtons = document.querySelectorAll(".js-login-menu");
		Array.from(loginButtons).map((x) => x.classList.remove("open"));
	}
}
// Login Menu ESC close
if(LOGINMENU && !LOGINMENU.classList.contains("esc-bound")) {
    LOGINMENU.addEventListener("keyup", function(event) {
        if(event.keyCode === 27) {
            closeLoginMenu();
        }
    });
    LOGINMENU.classList.add("esc-bound");
}


// Search Menu
function toggleSearchMenu(isOpen) {
	if(SEARCHMENU) {
		BODY.classList.toggle("menu-open");
		MENUSHROUD.classList.toggle("active");
		SEARCHMENU.classList.toggle("open");
		if(SEARCHMENU.classList.contains("open")) {
			focusFirst(SEARCHMENU);
		}
		let searchButtons = document.querySelectorAll(".js-search-menu");
		Array.from(searchButtons).map((x) => x.classList.toggle("open"));
	}
}
function openSearchMenu() {
	if(SEARCHMENU) {
		BODY.classList.toggle("menu-open");
		MENUSHROUD.classList.toggle("active");
		SEARCHMENU.classList.add("open");
		focusFirst(SEARCHMENU);
		let searchButtons = document.querySelectorAll(".js-search-menu");
		Array.from(searchButtons).map((x) => x.classList.add("open"));
	}
}
function closeSearchMenu() {
	if(SEARCHMENU) {
		BODY.classList.toggle("menu-open");
		MENUSHROUD.classList.toggle("active");
		SEARCHMENU.classList.remove("open");
		let searchButtons = document.querySelectorAll(".js-search-menu");
		Array.from(searchButtons).map((x) => x.classList.remove("open"));
	}
}
// Search Menu ESC close
if(SEARCHMENU && !SEARCHMENU.classList.contains("esc-bound")) {
    SEARCHMENU.addEventListener("keyup", function(event) {
        if(event.keyCode === 27) {
            closeSearchMenu();
        }
    });
    SEARCHMENU.classList.add("esc-bound");
}


// App Modal Menu
function toggleAppModal(isOpen) {
	if(APPMODAL) {
		BODY.classList.toggle("app-modal-open");
		MENUSHROUD.classList.toggle("active");
		APPMODAL.classList.toggle("open");
		let appButtons = document.querySelectorAll(".js-app-menu");
		Array.from(appButtons).map((x) => x.classList.toggle("open"));
	}
}
function openAppModal() {
	if(APPMODAL) {
		BODY.classList.toggle("app-modal-open");
		MENUSHROUD.classList.toggle("active");
		APPMODAL.classList.add("open");
		let appButtons = document.querySelectorAll(".js-app-menu");
		Array.from(appButtons).map((x) => x.classList.add("open"));
	}
}
function closeAppModal() {
	if(APPMODAL) {
		BODY.classList.toggle("app-modal-open");
		MENUSHROUD.classList.toggle("active");
		APPMODAL.classList.remove("open");
		let appButtons = document.querySelectorAll(".js-app-menu");
		Array.from(appButtons).map((x) => x.classList.remove("open"));
	}
}
// Search Menu ESC close
if(APPMODAL && !APPMODAL.classList.contains("esc-bound")) {
    APPMODAL.addEventListener("keyup", function(event) {
        if(event.keyCode === 27) {
            closeSearchMenu();
        }
    });
    APPMODAL.classList.add("esc-bound");
}


// Changing the menus inside of each dropdown
function changeSubMenu(menuElem, index) {
	let currentlyActiveMenuButton = menuElem.querySelector(".js-submenu-parent.active");
	let currentlyActiveMenuContent = menuElem.querySelector(".js-submenu-child.active");
	let clickedMenuButton = menuElem.querySelector(".js-submenu-parent[data-index='"+index+"']");
	let clickedMenuContent = menuElem.querySelector(".js-submenu-child[data-index='"+index+"']");
	if(currentlyActiveMenuButton == clickedMenuButton) {
		return;
	} else {
		currentlyActiveMenuButton.classList.remove("active");
		currentlyActiveMenuContent.classList.remove("active");
		clickedMenuButton.classList.add("active");
		clickedMenuContent.classList.add("active");
	}
}
// Event handler for the submenu buttons
document.addEventListener("click", (event) => {
	const clickTarget = event.target as HTMLElement;
	if(clickTarget.matches(".js-submenu-parent") && clickTarget.hasAttribute("data-index")) {
		changeSubMenu(clickTarget.closest(".dropdown"), clickTarget.getAttribute("data-index"));
	}
});


// Changing the submenus for the mobile navigation
function openSubmenu(clickedButton) {
	if(clickedButton.hasAttribute("data-child") && clickedButton.getAttribute("data-child")) {
		let openingNav = MOBILEMENU.querySelector("[data-nav='" + clickedButton.getAttribute("data-child") + "']");
		let parentNav = clickedButton.closest("[data-nav]");
		if(openingNav && parentNav) {
			parentNav.classList.add("covered");
			openingNav.classList.add("shown");
			setTimeout(function () {
				openingNav.classList.add("active");
			}, 1);
		}
	}
}
// Event handler for the subnav open buttons
document.addEventListener("click", (event) => {
	const clickTarget = event.target as HTMLElement;
	if(clickTarget.matches(".js-subnav-open")) {
		openSubmenu(event.target);
	}
});
// Close the subnavs
function closeSubmenu(clickedButton) {
	if(clickedButton.parentElement.hasAttribute("data-parent") && clickedButton.parentElement.getAttribute("data-parent")) {
		let parentNav = MOBILEMENU.querySelector("[data-nav='" + clickedButton.parentElement.getAttribute("data-parent") + "']");
		let closingNav = clickedButton.parentElement;
		if(parentNav && closingNav) {
			closingNav.classList.remove("active");
			setTimeout(function () {
				parentNav.classList.remove("covered");
				closingNav.classList.remove("shown");
			}, 251);
		}
	}
}
// Event handler for the subnav close buttons
document.addEventListener("click", (event) => {
	const clickTarget = event.target as HTMLElement;
	if(clickTarget.matches(".js-subnav-close")) {
		closeSubmenu(event.target);
	}
});


// Reset Open Menus when a submenu is opened, e.g.; Login button clicked in the Mobile Menu
function closeAllMenus(menuActivating) {
	let openMenus = document.querySelectorAll("section[id^=menu-].open");
	openMenus.forEach((menu:Element) => {
		const navMenu = menu as HTMLElement;
		if(navMenu != null && navMenu != menuActivating) {
			let menuWord = navMenu?.getAttribute("id")?.replace("menu-", "");
			switch(menuWord) {
				case "mobile":
					toggleMobileMenu(false);
					break;
				case "login":
					toggleLoginMenu();
					break;
				case "search":
					toggleSearchMenu(false);
					break;
				case "app":
					toggleAppModal(false);
					break;
			}
		}
	});
}


// Reset Open Menus when a submenu is opened, e.g.; Login button clicked in the Mobile Menu
function closeOtherOpenMenus(menuActivating) {
	let openMenus = document.querySelectorAll("section[id^=menu-].open");
	openMenus.forEach(function(menu) {
		const navMenu = menu as HTMLElement;

		if(navMenu != null && menu != menuActivating) {
			let menuWord = navMenu?.getAttribute("id")?.replace("menu-", "");
			switch(menuWord) {
				case "mobile":
					closeMobileMenu();
					break;
				case "search":
					closeSearchMenu();
					break;
				case "login":
					closeLoginMenu();
					break;
				case "app":
					closeAppModal();
					break;
			}
		}
	});
}

// Dropdown events
const allDropdownMenus = document.querySelectorAll(".main-nav > ul > li");
    let dropDownHoverIntents = new SV.HoverIntent(allDropdownMenus, {
        // required parameters
        onEnter: function (targetItem) {
            targetItem.classList.add("active");
            MENUSHROUD.classList.add("active");
        },
        onExit: function (targetItem) {
            targetItem.classList.remove("active");
            MENUSHROUD.classList.remove("active");
        },
        // default options
        exitDelay: 400,
        interval: 100,
        sensitivity: 7,
    });

// // Dropdown events
// const allDropdownMenus = document.querySelectorAll(".main-nav > ul > li");
// allDropdownMenus.forEach(function (menu) {
//     menu.addEventListener("mouseenter", function() {
//         menu.classList.add("active");
//         MENUSHROUD.classList.add("active");
//     });
//     menu.addEventListener("mouseleave", function() {
//         menu.classList.remove("active");
//         MENUSHROUD.classList.remove("active");
//     });
// });

// Link only primary navs
let allDropdownLinks = document.querySelectorAll("header .js-link-only");
allDropdownLinks.forEach(function (menu) {
    menu.addEventListener("mouseenter", function() {
        menu.classList.add("active");
    });
    menu.addEventListener("mouseleave", function() {
        menu.classList.remove("active");
    });
});

// Click Events
document.addEventListener(
	"click",
	function (e) {
		const clickTarget = e.target as HTMLElement;
		if (clickTarget.matches(".js-mobile-menu")) {
			// Mobile Navigation Menu
			toggleMobileMenu(false);
			closeAllMenus(MOBILEMENU);
		} else if (clickTarget.matches(".js-login-menu")) {
			// Login Menu
			toggleLoginMenu();
			closeAllMenus(LOGINMENU);
		} else if (clickTarget.matches(".js-search-menu")) {
			// Login Menu
			toggleSearchMenu(false);
			closeAllMenus(SEARCHMENU);
		} else if (clickTarget.matches(".js-app-menu")) {
			// Login Menu
			toggleAppModal(false);
			closeAllMenus(APPMODAL);
		} else if (clickTarget == MENUSHROUD) {
			closeAllMenus("all");
		}
		// else if (e.target.matches("[data-video]")) {
		// 	// Video Modal
		// 	if (e.target.getAttribute("data-video") != "") {
		// 		e.preventDefault();
		// 		let videoTitle = "";
		// 		let videoGUID = "";
		// 		let ada_text = e.target.querySelector("span.visuallyhidden");
		// 		if(ada_text && ada_text.innerText != "") {
		// 			videoTitle = e.target.querySelector("span.visuallyhidden").innerText;
		// 		}
		// 		var vidBuild =
		// 			"<div class='video-modal-content'><button class='video-modal-close'>&times;<span class='visuallyhidden'> close</span></button>";
		// 		if (e.target.getAttribute("data-video").indexOf("vimeo") != -1) {
		// 			var vid = e.target.getAttribute("data-video").replace("https://vimeo.com/", "");
		// 			if (vid.indexOf("/") != -1) {
		// 				vid = vid.substring(0, vid.indexOf("/"));
		// 			}
		// 			vidBuild +=
		// 				"<div style='padding: 56.25% 0 0 0; position: relative;'><iframe src='https://player.vimeo.com/video/" +
		// 				vid +
		// 				"?title=0&byline=0&portrait=0' alt='" +
		// 				videoTitle +
		// 				"' style='position:absolute;top:0;left:0;width:100%;height:100%;' frameborder='0' allow='autoplay; fullscreen' allowfullscreen></iframe></div><script src='https://player.vimeo.com/api/player.js'></script>";
		// 			vidBuild +=
		// 				"<div class='transcript-container js-accordion'><button class='transcript-button js-accordion-button' type='button' aria-expanded='false'>Video Transcript</button><div class='transcript-content js-accordion-content'><p>This video uses Vimeo's native closed captioning features to provide a transcript. If closed captioning is unavailable for this video, please <a href='/contact'>contact us</a> and we can provide you with one.</p></div></div>";
		// 		} else if (e.target.getAttribute("data-video").indexOf("youtube") != -1) {
		// 			var vid = e.target
		// 				.getAttribute("data-video")
		// 				.replace("https://www.youtube.com/watch?v=", "");
		// 			if (vid.indexOf("/") != -1) {
		// 				vid = vid.substring(0, vid.indexOf("/"));
		// 			}
		// 			vidBuild +=
		// 				"<div style='padding: 56.25% 0 0 0; position: relative;'><iframe src='https://www.youtube.com/embed/" +
		// 				vid +
		// 				"' alt='" +
		// 				videoTitle +
		// 				"' style='position:absolute;top:0;left:0;width:100%;height:100%;' frameborder='0' allow='accelerometer; autoplay; encrypted - media; gyroscope; picture -in -picture; fullscreen' allowfullscreen></iframe></div>";
		// 			vidBuild +=
		// 				"<div class='transcript-container js-accordion'><button class='transcript-button js-accordion-button' type='button' aria-expanded='false'>Video Transcript</button><div class='transcript-content js-accordion-content'><p>This video uses YouTube's native closed captioning features to provide a transcript. If closed captioning is unavailable for this video, please <a href='/contact'>contact us</a> and we can provide you with one.</p></div></div>";
		// 		} else if (e.target.getAttribute("data-video").indexOf(".mp4")) {
		// 			videoGUID = e.target.getAttribute("data-video").split("/")[2];
		// 			vidBuild +=
		// 				"<video width='100%' controls autoplay><source src='" +
		// 				e.target.getAttribute("data-video") +
		// 				"' type='video/mp4'></video>";
		// 			// Since the transcript is queried async, make a holder for it and we'll append the content after the async completes
		// 			vidBuild +=
		// 				"<div class='transcript-container js-accordion'><button class='transcript-button js-accordion-button' type='button' aria-expanded='false'>Video Transcript</button><div id='transcript-" +
		// 				videoGUID +
		// 				"' class='transcript-content js-accordion-content'><p>For a transcript of this video, please <a href='/contact'>contact us</a>.</p></div></div>";
		// 		}
		// 		vidBuild += "</div>";

		// 		var vidModal = document.querySelector(".video-modal");
		// 		if (vidModal !== null) {
		// 			vidModal.parentNode.removeChild(vidModal);
		// 		}

		// 		var div = document.createElement("div");
		// 		div.classList.add("video-modal");
		// 		div.innerHTML = vidBuild;

		// 		BODY.appendChild(div);

		// 		if (videoGUID != "" && document.getElementById("transcript-" + videoGUID) != undefined) {
		// 			// If it's embedded, get the transcript
		// 			let xhr = new XMLHttpRequest();
		// 			xhr.open("GET", "/transcript/" + videoGUID);
		// 			xhr.send();
		// 			xhr.onload = function () {
		// 				if (xhr.status === 200 && xhr.responseText.replace(/\"/gm, "") != "") {
		// 					// console.log("Transcrpt Retrieval Succeeded, Status: " + xhr.status + ".");
		// 					document.getElementById("transcript-" + videoGUID).innerHTML =
		// 						"<p>" +
		// 						xhr.responseText.replace(/\"/gm, "").replace(/\\r\\n/gm, "<br />") +
		// 						"</p>";
		// 				} else {
		// 					// console.log("Transcrpt Retrieval Failed, Status: " + xhr.status + ".");
		// 				}
		// 			};
		// 			xhr.onerror = function () {
		// 				// console.log("Transcript Retrieval Error: " + xhr.status + ".");
		// 			};
		// 		}
		// 	}
		// } else if (e.target.matches(".video-modal")) {
		// 	// Video Modal
		// 	e.target.parentNode.removeChild(e.target);
		// } else if (e.target.matches(".video-modal-content")) {
		// 	// Video Modal
		// 	e.stopPropagation();
		// } else if (e.target.matches(".video-modal-close")) {
		// 	// Closing the video modal
		// 	e.preventDefault();
		// 	var vidModal = document.querySelector(".video-modal");
		// 	if (vidModal !== null) {
		// 		vidModal.parentNode.removeChild(vidModal);
		// 	}
		// }
	},
	false
);

/********************************************************
 ** Home ALERTS
 ********************************************************/
/*
    Close function for the alerts banner.
*/
// Alerts
const ALERTS = document.getElementById("site-alerts");
if(ALERTS) {
	let theAlerts = ALERTS.querySelectorAll(".mod-alert");
	theAlerts.forEach(function(alert) {
		let alertDismissed = getCookieValue("pm_site_alert_dismissed_"+alert.getAttribute("data-alertid"));
		if(alertDismissed != "true") {
			alert.classList.remove("dismissed");
		}
	});
}
document.addEventListener("click", function (e) {
	const clickTarget = e.target as HTMLElement;
	if (clickTarget.matches(".js-alert-close")) {
		let theAlert = clickTarget.closest(".mod-alert") as HTMLElement;
		let alertID = theAlert.getAttribute("data-alertid");
		let expires = new Date();
		expires.setDate(expires.getDate() + 365);
		document.cookie = "pm_site_alert_dismissed_"+alertID+"=true; path=/; expires=" + expires.toUTCString() + "; SameSite=None; Secure";
		theAlert.classList.add("dismissed");
	}
});


/********************************************************
 ** LOCATION ALERTS
 ********************************************************/
/*
    Close function for the alerts banner.
*/
document.addEventListener("click", function (event) {
	const clickTarget = event.target as HTMLElement;
	if (clickTarget.classList.contains("js-location-alert-close")) {
		let alertID = parseInt(clickTarget.parentElement.parentElement.getAttribute("data-alertid"));
		if (!isNaN(alertID) && alertID > -1) {
			var expires = new Date();
			expires.setDate(expires.getDate() + 7);
			document.cookie =
				"pm_location_alert_dismissed_" +
				alertID +
				"=true; path=/; expires=" +
				expires.toUTCString() +
				"; SameSite=None; Secure";
			vHide(clickTarget.parentElement.parentElement);
		}
	}
});



/** JUMP NAVS ***/
var jumplinkObserver = new IntersectionObserver(
	function (entries) {
		entries.forEach(function (entry) {
			const clickTarget = entry.target as HTMLElement;
			if (clickTarget.matches("[data-jumplnk]")) {
				if (entry.isIntersecting) {
					var jumps = document.querySelectorAll(".js-links .jump-lnk");
					jumps.forEach(function (jp) {
						const jump = jp as HTMLElement;
						if (
							jump.innerText.trim() ==
							clickTarget.getAttribute("data-jumplnk").replace(/_/g, " ").trim()
						) {
							jump.classList.add("active");
						} else {
							jump.classList.remove("active");
						}
					});
				}
			}
		});
	},
	{ rootMargin: "-50px 0px 0px 0px", threshold: [0.00001] }
);
// The element to observe
document.addEventListener("DOMContentLoaded", () => {
	let jumpslinks = document.querySelectorAll("[data-jumplnk]");
	// Attach it to the observer
	jumpslinks.forEach(function (item) {
		jumplinkObserver.observe(item);
	});
});


//close search on escape key
document.addEventListener('keyup', (e) => {
	if (e.key == "Escape") {
		if (BODY.classList.contains('search-open')) {
			toggleSearchMenu(false);
		}
	}
});


// //Search modal
// const searchBtns = document.querySelectorAll(".js-search-menu");
// searchBtns.forEach((btn) => {
// 	const clickTarget = btn as HTMLElement;

// 	btn.classList.add(".open");
// });
// const searchCloseBtns = document.querySelectorAll(".")

// Pop-up Alert
if(POPUPALERT && POPUPALERT.getAttribute("data-status") == "enabled") {
	let popupAlertVersion = POPUPALERT.getAttribute("data-ver");
	let popupAlertDismissed = getCookieValue("pm_site_popup_alert_dismissed_"+popupAlertVersion);
	if(popupAlertDismissed != "true") {
		POPUPALERT.classList.add("active");
		BODY.classList.add("menu-open");
		let closePopupButtons = document.querySelectorAll(".js-popup-alert-close");
		closePopupButtons.forEach((button) => {
			button.addEventListener("click", (event) => {
				var expires = new Date();
				expires.setDate(expires.getDate() + 7);
				document.cookie = "pm_site_popup_alert_dismissed_" + popupAlertVersion + "=true; path=/; expires=" + expires.toUTCString() + "; SameSite=None; Secure";
				POPUPALERT.classList.remove("active");
				BODY.classList.remove("menu-open");
				setTimeout(function () {
					POPUPALERT.setAttribute("data-status", "disabled");
				}, 1001);
			});
		});
	} else {
		POPUPALERT.setAttribute("data-status", "disabled");
	}
}